import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 24, className = "", once = true }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once, margin: "-80px" }}
    transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const Overline = ({ children, className = "" }) => (
  <span
    className={`inline-flex items-center gap-3 text-xs md:text-sm uppercase tracking-[0.25em] text-brand-light font-semibold ${className}`}
  >
    <span className="h-px w-8 bg-brand-light/60" />
    {children}
  </span>
);
